import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Button,
  Box,
  Chip,
  Stack,
} from "@mui/material";

const MissingReturnsTickers = ({ open, onClose, missingReturnsTickers }) => {
  if (!missingReturnsTickers?.length) return null;

  const symbols = missingReturnsTickers
    .map((ticker) => ticker?.symbol)
    .filter(Boolean);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm">
      <DialogTitle>
        <Typography
          variant="h6"
          component="div"
          align="center"
          style={{ flexGrow: 1, fontSize: "20px" }}
        >
          Performance Calculation Missing Some Stocks{" "}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Can't get returns for these stocks as they are no longer actively traded public stocks:
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1,
            mb: 3,
            maxHeight: "200px",
            overflowY: "auto",
          }}
        >
          {symbols?.map((symbol) => (
            <Chip
              key={symbol}
              label={symbol}
              variant="filled"
              sx={{
                fontWeight: 500,
                fontSize: "13px",
              }}
            />
          ))}
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button onClick={onClose} variant="contained">
            Close
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default MissingReturnsTickers;
